import ObjectCopyService from "external-services/object-copy-service/index";
import template from "./durationDrag.html";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import BookingUpdateService from "external-services/booking-update-service/index";
import {
  BookingMethods,
} from "shared-types/index";

const NS = 'DurationDrag'; // jshint ignore:line

export default function DurationDrag(  // as durationDrag
  $document, $mdDialog, unregister
) {
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    scope: {
      booking: '=',
      minuteLength: '='
    },
    template,
    controllerAs: 'vm',
    controller
  };

  function controller($scope) {
    "ngInject";

    var vm = this;
    var orgMouseX;
    var orgDuration;
    var orgBooking = ObjectCopyService.angularSafeCopy($scope.booking);

    var listeners = [];
    listeners.push($scope.$watch('booking', init));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    if (!AdminService.isPartnerBookingsLocked(orgBooking.partner))
      vm.startDurationDrag = startDurationDrag;

    function init() {
      orgBooking = ObjectCopyService.angularSafeCopy($scope.booking);
    }

    function startDurationDrag(evt) {
      evt.preventDefault();
      orgMouseX = evt.pageX;
      orgDuration = ObjectCopyService.angularSafeCopy($scope.booking.duration);
      $document.on('mousemove', mousemove);
      $document.on('mouseup', mouseup);
    }

    function mousemove(evt) {
      var x = evt.pageX;
      $scope.$evalAsync(function () {
        var duration = Math.floor(orgDuration + ((x - orgMouseX) / $scope.minuteLength));
        duration = (duration < 30) ? 30 : duration;
        $scope.booking.duration = duration;
      });
    }

    function mouseup(event, message) {
      // check couch url/name still correct
      AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
      AdminService.loadVenue(AdminService.getVenue().id, true, true).then(() => {

        // Open staff dialog if needed
        GeneralSettingsService.get().then(function (settings) {
          const isOldEditSettings = settings.staffEditEnabled && !settings.staffEdit;
          const isNewEditSettings = settings.staffEdit && settings.staffEdit.staffEditQuickEdit;
          if ((isOldEditSettings || isNewEditSettings) && settings.staffEditEnabled && orgBooking.method !== BookingMethods.walkin) {
            vm.open = false;
            var staffNameDialog = $mdDialog.prompt()
              .title('Booking change')
              .placeholder('Staff name')
              .ariaLabel('Staff name')
              .targetEvent(event)
              .ok('Confirm')
              .cancel('Cancel')
              .clickOutsideToClose(true);

            if (message) {
              staffNameDialog.textContent(message);
            }

            $mdDialog.show(staffNameDialog).then(function (staff) {
              // required check is here because AngularJS Material 1.0.7 doesn't have a 'required' stetting for prompt dialogs
              if (settings.staffEditRequired && !staff) {
                mouseup(event, 'Staff name required');
              } else {
                update(staff);
              }
            }).catch((err) => {
              if (err) {
                console.error(err);
              }
              $scope.booking.duration = orgDuration;
            });
          } else {
            update();
            vm.open = false;
          }
        });
      }).catch(function (err) {
        console.error(err);
      });
      $document.unbind('mousemove', mousemove);
      $document.unbind('mouseup', mouseup);
    }

    function update(staff) {
      BookingUpdateService.updateFromAnywhere($scope.booking, orgBooking, null, null, staff);
      orgBooking = ObjectCopyService.angularSafeCopy($scope.booking);
    }
  }
}
